import { memo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-cassette-ai-large.tsx
/**
* icon.24.logo.cassette-ai.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTUuNzQ1IDExLjc1SDd2LjVINS43NDV2MS4yNTRoLS41VjEyLjI1SDR2LS41aDEuMjQ1di0xLjI0NmguNXptMTMtLjAwNEgyMHYuNWgtMS4yNTVWMTMuNWgtLjV2LTEuMjU0SDE3di0uNWgxLjI0NVYxMC41aC41eiIgb3BhY2l0eT0iLjQiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMTguNSA5LjVhMi41IDIuNSAwIDEgMS0yLjQ0NyAzLjAxcS0xLjg4OS4wNi00LjE1LS4zOTJjLTEuNDc0LS4yOTUtMi43OC0uMi0zLjkzNC4yNThBMi40OTggMi40OTggMCAwIDEgMyAxMmEyLjQ5OCAyLjQ5OCAwIDAgMSA0LjkwNi0uNjY4YzEuMjgtLjQzOSAyLjY4My0uNDk2IDQuMTkzLS4xOTQgMS40NjEuMjkyIDIuNzc3LjQxMiAzLjk0OS4zNzNBMi41IDIuNSAwIDAgMSAxOC41IDkuNW0tMTMgMWExLjUgMS41IDAgMSAwIDAgMyAxLjUgMS41IDAgMCAwIDAtM20xMyAwYTEuNSAxLjUgMCAxIDAgMCAzIDEuNSAxLjUgMCAwIDAgMC0zbTAgMWEuNS41IDAgMSAxIDAgMSAuNS41IDAgMCAxIDAtMW0tMTMtLjAwMWEuNS41IDAgMSAxIDAgMSAuNS41IDAgMCAxIDAtMSIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26838-10832
*/
const Icon24LogoCassetteAiLarge = memo(function Icon24LogoCassetteAiLarge(props) {
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: [/* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color-3, var(--color-icon-tertiary))",
			d: "M5.745 11.75H7v.5H5.745v1.254h-.5V12.25H4v-.5h1.245v-1.246h.5zm13-.004H20v.5h-1.255V13.5h-.5v-1.254H17v-.5h1.245V10.5h.5z",
			opacity: ".4"
		}), /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M18.5 9.5a2.5 2.5 0 1 1-2.447 3.01q-1.889.06-4.15-.392c-1.474-.295-2.78-.2-3.934.258A2.498 2.498 0 0 1 3 12a2.498 2.498 0 0 1 4.906-.668c1.28-.439 2.683-.496 4.193-.194 1.461.292 2.777.412 3.949.373A2.5 2.5 0 0 1 18.5 9.5m-13 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m13 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m0 1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m-13-.001a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1"
		})]
	});
});
//#endregion
export { Icon24LogoCassetteAiLarge };

//# sourceMappingURL=icon-24-logo-cassette-ai-large.js.map